<template>
    <div v-show="type != 'hidden'" class="field singleline" :class="{ 'required': required }">
        <div v-if="label" class="heading">
            <label>{{ label }}</label>
        </div>
        <div class="input">
            <input :value="newValue" :type="type" :name="name" :required="required" :readonly="readonly" v-bind="$attrs" @input="$emit('update:value', $event.target.value)">
            <span v-if="unit" class="unit" v-html="unit" />
        </div>
        <p v-if="error && required && !value" class="error text--orange small semi">
            {{ error }}
        </p>
    </div>
</template>

<script>
export default {
    inheritAttrs: false,

    props: {
        label: {
            type: String,
            default: null,
        },
        value: {
            type: [String, Number],
            default: null,
        },
        name: {
            type: String,
            required: true
        },
        required: {
            type: Boolean,
            default: false
        },
        unit: {
            type: String,
            default: null,
        },
        readonly: {
            type: Boolean,
            default: false
        },
        tooltip: {
            type: String,
            default: null,
        },
        type: {
            type: String,
            default: 'text'
        },
        error: {
            type: String,
            default: null
        }
    },

    computed: {
        newValue() {
            return this.value;
        },
    },
}
</script>

<style lang="scss" scoped>
    .input {
        align-items: center !important;
        border-bottom: 1px solid #DDDDDD;
    }

    input {
        border: 0 !important;
    }

    .unit {
        margin-left: 0.5em;
        color: #AFAFAF;
        font-weight: 500;
        white-space: nowrap;
    }

    .tool {
        margin-left: 0.5em;

        &::v-deep .tool-icon {
            background-color: #AFAFAF;
        }
    }
</style>
